import * as React from "react";

export const Automation = () => (
    <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.74263 8.43723C4.70101 8.48535 4.71432 8.55959 4.77006 8.59026L7.263 9.96174C7.30385 9.98421 7.32375 10.0319 7.31096 10.0768L6.13678 14.1923C6.10741 14.2953 6.23854 14.3662 6.30858 14.2852L11.3457 8.46125C11.3906 8.40935 11.3711 8.3287 11.3074 8.30307L8.49847 7.17185C8.44911 7.15197 8.42396 7.09692 8.44125 7.04659L9.91836 2.74771C9.95411 2.64367 9.82012 2.56659 9.74815 2.6498L4.74263 8.43723ZM9.9155 6.44886L11.0532 3.13766C11.518 1.78507 9.77611 0.783074 8.84053 1.8648L3.83501 7.65223C3.29393 8.27782 3.46695 9.24297 4.19164 9.64166L5.91649 10.5906L4.98283 13.8631C4.60093 15.2017 6.30562 16.123 7.2162 15.0702L12.2533 9.24625C12.8368 8.57161 12.5831 7.52315 11.7557 7.18995L9.9155 6.44886Z"
    />
);
